import ClipboardJS from 'clipboard';
import notie from 'notie';

import 'notie/dist/notie.css';
import 'font-awesome/css/font-awesome.css';
import 'pace-js/themes/blue/pace-theme-minimal.css';
import 'blueimp-file-upload/css/jquery.fileupload.css';
import 'dragula/dist/dragula.min.css';
import 'pickadate/lib/themes/default.css';
import 'pickadate/lib/themes/default.date.css';
import 'pickadate/lib/themes/default.time.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-select-dt/css/select.dataTables.min.css';
import '../css/main.scss';

$(function () {
  var module_timer = function () {
    var timer_obj = null;
    var timed_elements = [];
    var second = 1000;
    var minute = 60 * second;
    var hour = 60 * minute;
    var minutesToShowSeconds = 10;
    var interval = second;

    var update_element = function (timer_element, timer_value) {
      var hours = Math.floor(timer_value / hour);
      var minutes = Math.floor((timer_value - hours * hour) / minute);
      var seconds = Math.floor(
        (timer_value - hours * hour - minutes * minute) / second
      );
      var text = '';
      if (hours > 0) {
        text += hours + (hours === 1 ? ' hr' : ' hrs');
      }
      if (minutes > 0) {
        if (text !== '') {
          text += ', ';
        }
        text += minutes + (minutes === 1 ? ' min' : ' mins');
      }
      if (hours === 0 && minutes < minutesToShowSeconds) {
        if (timer_element.hasClass('remaining_time-timer')) {
          timer_element.addClass('bg-red');
        }
        if (seconds > 0 || (seconds === 0 && minutes === 0)) {
          if (text !== '') {
            text += ', ';
          }
          text += seconds + (seconds === 1 ? ' sec' : ' secs');
        }
      }
      timer_element.text(text);
      if (timer_value === 0) {
        clearInterval(timer_obj);
        if (location.pathname === window.RAIQC_URLS.USER_MODULES) {
          location.reload(true);
        } else {
          location.href = window.RAIQC_URLS.USER_MODULES;
        }
      }
    };

    return this.each(function () {
      var element = $(this);
      var remaining = element.data('remaining-time');
      if (!remaining) {
        return;
      }

      update_element(element, parseInt(remaining));

      if (element.hasClass('remaining_time-timer')) {
        // Keep track of the elements that need to be updated
        timed_elements.push(element);

        if (!timer_obj) {
          // Set the interval to update the elements (only once)
          timer_obj = setInterval(function () {
            // Update the time remaining for each element
            timed_elements.forEach(function (timer_element) {
              var remaining = parseInt(timer_element.data('remaining-time'));
              var timer_value = Math.max(remaining - interval, 0);

              timer_element.data('remaining-time', timer_value);
              update_element(timer_element, timer_value);
            });
          }, interval);
        }
      }
    });
  };

  $.fn.extend({ module_timer: module_timer });

  $('.remaining_time').module_timer();

  $('[data-toggle="popover"]').popover({
    content: function () {
      var target = $(this).data('target');
      if (target) {
        return $(target).html();
      }
      return '';
    },
  });

  $('[data-toggle="tooltip"]').tooltip();

  $(document).on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget);
    var url = button.data('target-url');
    if (url) {
      var title = button.data('target-title') || button.attr('title');
      $('.modal-title', this).text(title);
      $(this).attr('aria-labelledby', title);

      $('.modal-body', this).load(url, function () {
        $('#load-modal').modal('toggle');
      });
    }
  });

  $('.pickadate')
    .wrap('<div class="input-group">')
    .before(
      '<div class="input-group-prepend"><span class="input-group-text">' +
        '<i class="fa fa-calendar-o"></i></span></div>'
    )
    .pickadate({ format: 'dd/mm/yyyy' });

  $('.btn-group-disabled .btn').addClass('disabled');
  $('.btn-group-disabled.disabled-for-demo').click(function () {
    $('#modalDemoSignup').modal('show');
  });

  new ClipboardJS('[data-clipboard-text],[data-clipboard-target]');

  // Stripe integration
  $(document).on('click', '.stripe-pay', function (event) {
    event.preventDefault();

    var $button = $(event.target);
    var $form = $button.closest('form');
    var key = $button.data('key');

    $.post($form.attr('action'), $form.serialize())
      .done(function (data) {
        if (data.session_id) {
          window
            .Stripe(key)
            .redirectToCheckout({ sessionId: data.session_id })
            .then(function (result) {
              notie.alert({
                type: 'error',
                text: result.error.message,
              });
            });
        } else if (data.html) {
          $form.html(data.html);
        }
        if (data.messages) {
          data.messages.forEach(function (message) {
            notie.alert({ text: message.message });
          });
        }
      })
      .fail(function () {
        notie.alert({
          type: 'error',
          text: 'Failed to initite payment.',
        });
      });

    return false;
  });

  // If the stripe-pay session-id is set then redirect to checkout
  $('.stripe-pay[data-session-id]').each(function () {
    var key = $(this).data('key');
    var sessionId = $(this).data('session-id');
    if (key && sessionId) {
      window.Stripe(key).redirectToCheckout({ sessionId: sessionId });
      // Only process one session
      return false;
    }
  });

  // Make "Normal" mutually exclusive with other diagnosis options
  $('#answericometrix_diagnosis0').change(function () {
    var checked = $(this).is(':checked');
    var $others = $(this)
      .parents('.form-check')
      .find('input[type="checkbox"]')
      .not($(this));
    // enable or disable the others
    $others.attr('disabled', checked);
    // uncheck the others
    $others.prop('checked', false);
  });
});

// Modal for some messages
$(window).on('load', function () {
  $('#message-modal').modal('show');
});

$(window).on('load', function () {
  $('.carousel').carousel({
    interval: 2000,
  });
});
